/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    NewUserTag,
    NewUserTagCategoryWithTags,
    UpdatableTag,
    UserTagCategoryId,
    UserTagCategoryWithTagsView,
    UserTagId,
    UserTagOverview,
    UserTagOverviewListDto,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const deleteTagCategoriesTagCategoryId = (
    tagCategoryId: UserTagCategoryId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/tag-categories/${tagCategoryId}`, options);
};

export const getDeleteTagCategoriesTagCategoryIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteTagCategoriesTagCategoryId>>,
        TError,
        { tagCategoryId: UserTagCategoryId },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteTagCategoriesTagCategoryId>>,
    TError,
    { tagCategoryId: UserTagCategoryId },
    TContext
> => {
    const mutationKey = ["deleteTagCategoriesTagCategoryId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteTagCategoriesTagCategoryId>>,
        { tagCategoryId: UserTagCategoryId }
    > = (props) => {
        const { tagCategoryId } = props ?? {};

        return deleteTagCategoriesTagCategoryId(tagCategoryId, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteTagCategoriesTagCategoryIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteTagCategoriesTagCategoryId>>
>;

export type DeleteTagCategoriesTagCategoryIdMutationError = AxiosError<unknown>;

export const useDeleteTagCategoriesTagCategoryId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteTagCategoriesTagCategoryId>>,
            TError,
            { tagCategoryId: UserTagCategoryId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteTagCategoriesTagCategoryId>>,
    TError,
    { tagCategoryId: UserTagCategoryId },
    TContext
> => {
    return useMutation(
        getDeleteTagCategoriesTagCategoryIdMutationOptions(options),
        queryClient
    );
};
export const postTagCategories = (
    newUserTagCategoryWithTags: NewUserTagCategoryWithTags,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserTagCategoryWithTagsView>> => {
    return axios.post(
        `/api/tag-categories`,
        newUserTagCategoryWithTags,
        options
    );
};

export const getPostTagCategoriesMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postTagCategories>>,
        TError,
        { data: NewUserTagCategoryWithTags },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postTagCategories>>,
    TError,
    { data: NewUserTagCategoryWithTags },
    TContext
> => {
    const mutationKey = ["postTagCategories"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postTagCategories>>,
        { data: NewUserTagCategoryWithTags }
    > = (props) => {
        const { data } = props ?? {};

        return postTagCategories(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostTagCategoriesMutationResult = NonNullable<
    Awaited<ReturnType<typeof postTagCategories>>
>;
export type PostTagCategoriesMutationBody = NewUserTagCategoryWithTags;
export type PostTagCategoriesMutationError = AxiosError<unknown>;

export const usePostTagCategories = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postTagCategories>>,
            TError,
            { data: NewUserTagCategoryWithTags },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postTagCategories>>,
    TError,
    { data: NewUserTagCategoryWithTags },
    TContext
> => {
    return useMutation(
        getPostTagCategoriesMutationOptions(options),
        queryClient
    );
};
export const putTagsTagId = (
    tagId: UserTagId,
    updatableTag: UpdatableTag,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserTagOverview>> => {
    return axios.put(`/api/tags/${tagId}`, updatableTag, options);
};

export const getPutTagsTagIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putTagsTagId>>,
        TError,
        { tagId: UserTagId; data: UpdatableTag },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof putTagsTagId>>,
    TError,
    { tagId: UserTagId; data: UpdatableTag },
    TContext
> => {
    const mutationKey = ["putTagsTagId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof putTagsTagId>>,
        { tagId: UserTagId; data: UpdatableTag }
    > = (props) => {
        const { tagId, data } = props ?? {};

        return putTagsTagId(tagId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutTagsTagIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof putTagsTagId>>
>;
export type PutTagsTagIdMutationBody = UpdatableTag;
export type PutTagsTagIdMutationError = AxiosError<unknown>;

export const usePutTagsTagId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof putTagsTagId>>,
            TError,
            { tagId: UserTagId; data: UpdatableTag },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof putTagsTagId>>,
    TError,
    { tagId: UserTagId; data: UpdatableTag },
    TContext
> => {
    return useMutation(getPutTagsTagIdMutationOptions(options), queryClient);
};
export const deleteTagsTagId = (
    tagId: UserTagId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/tags/${tagId}`, options);
};

export const getDeleteTagsTagIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteTagsTagId>>,
        TError,
        { tagId: UserTagId },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteTagsTagId>>,
    TError,
    { tagId: UserTagId },
    TContext
> => {
    const mutationKey = ["deleteTagsTagId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteTagsTagId>>,
        { tagId: UserTagId }
    > = (props) => {
        const { tagId } = props ?? {};

        return deleteTagsTagId(tagId, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteTagsTagIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteTagsTagId>>
>;

export type DeleteTagsTagIdMutationError = AxiosError<unknown>;

export const useDeleteTagsTagId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteTagsTagId>>,
            TError,
            { tagId: UserTagId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteTagsTagId>>,
    TError,
    { tagId: UserTagId },
    TContext
> => {
    return useMutation(getDeleteTagsTagIdMutationOptions(options), queryClient);
};
export const getTags = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserTagOverviewListDto>> => {
    return axios.get(`/api/tags`, options);
};

export const getGetTagsQueryKey = () => {
    return [`/api/tags`] as const;
};

export const getGetTagsQueryOptions = <
    TData = Awaited<ReturnType<typeof getTags>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getTags>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTagsQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTags>>> = ({
        signal,
    }) => getTags({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTags>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTagsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTags>>
>;
export type GetTagsQueryError = AxiosError<unknown>;

export function useGetTags<
    TData = Awaited<ReturnType<typeof getTags>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getTags>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getTags>>,
                    TError,
                    Awaited<ReturnType<typeof getTags>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTags<
    TData = Awaited<ReturnType<typeof getTags>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getTags>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getTags>>,
                    TError,
                    Awaited<ReturnType<typeof getTags>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTags<
    TData = Awaited<ReturnType<typeof getTags>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getTags>>, TError, TData>
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTags<
    TData = Awaited<ReturnType<typeof getTags>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getTags>>, TError, TData>
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetTagsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTagsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getTags>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getTags>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTagsQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTags>>> = ({
        signal,
    }) => getTags({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTags>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTagsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTags>>
>;
export type GetTagsSuspenseQueryError = AxiosError<unknown>;

export function useGetTagsSuspense<
    TData = Awaited<ReturnType<typeof getTags>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTags>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTagsSuspense<
    TData = Awaited<ReturnType<typeof getTags>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTags>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTagsSuspense<
    TData = Awaited<ReturnType<typeof getTags>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTags>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTagsSuspense<
    TData = Awaited<ReturnType<typeof getTags>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTags>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetTagsSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postTags = (
    newUserTag: NewUserTag,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserTagOverview>> => {
    return axios.post(`/api/tags`, newUserTag, options);
};

export const getPostTagsMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postTags>>,
        TError,
        { data: NewUserTag },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postTags>>,
    TError,
    { data: NewUserTag },
    TContext
> => {
    const mutationKey = ["postTags"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postTags>>,
        { data: NewUserTag }
    > = (props) => {
        const { data } = props ?? {};

        return postTags(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostTagsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postTags>>
>;
export type PostTagsMutationBody = NewUserTag;
export type PostTagsMutationError = AxiosError<unknown>;

export const usePostTags = <TError = AxiosError<unknown>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postTags>>,
            TError,
            { data: NewUserTag },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postTags>>,
    TError,
    { data: NewUserTag },
    TContext
> => {
    return useMutation(getPostTagsMutationOptions(options), queryClient);
};
